import { useEffect, useRef, useState } from 'react'

const StatusCardsWrapper = ({ children, className = '' }) => {
  const ref = useRef(null)
  const [hasChildren, setHasChildren] = useState(true)

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const visibleChildren = ref.current?.children?.length || 0
      setHasChildren(visibleChildren > 0)
    })

    if (ref.current) {
      observer.observe(ref.current, { childList: true })
    }

    return () => observer.disconnect()
  }, [])

  if (!hasChildren) return null

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  )
}

export default StatusCardsWrapper
